import React, { InputHTMLAttributes, ReactElement } from "react";
import { withDefault } from "../../utils/withDefault";
import { If } from "./If";

type AppInputColor = "blue-gray" | "gray" | "white" | "green";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  color?: AppInputColor;
  className?: string;
  error?: string | null;
}

export function AppInput(props: Props): ReactElement {
  const classNames = ["AppInput", props.className];

  if (typeof props.error === "string") {
    classNames.push("Invalid");
  }

  return (
    <div className="AppInputWrapper">
      <If condition={typeof props.error === "string"} comment="has errors">
        <span className="AppInputError">{props.error}</span>
      </If>
      <input
        {...props}
        className={classNames.join(" ")}
        type={withDefault(props.type, "text")}
        data-color={withDefault(props.color, "blue-gray")}
      />
    </div>
  );
}
